import { getPrefectureName, PrefectureCode } from "enums";
import React from "react";
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";

type PROPS = {
  label: string;
  /** 表示する都道府県コードのリスト */
  prefectures: PrefectureCode[];
  /** 選択中の都道府県番号 */
  selectedPrefectureCode: string;
  /**  */
  onChangePrefectureCode: (code: PrefectureCode) => void;
};

const CorpListSideMenuTreeNode: React.FC<PROPS> = (props) => {
  const [opened, setOpened] = React.useState(false);

  /** 選択中の都道府県を含む場合はアクティブ */
  const isActive = (code: PrefectureCode | string, list: PrefectureCode[]) => {
    return list.includes(code as PrefectureCode);
  };

  const onChange = () => {
    if (opened === false) {
      setOpened(true);
    } else {
      if (isActive(props.selectedPrefectureCode, props.prefectures)) {
        //
      } else {
        setOpened(false);
      }
    }
  };

  React.useEffect(() => {
    const code = props.selectedPrefectureCode;
    if (isActive(code, props.prefectures)) {
      setOpened(true);
    }
  }, [props.selectedPrefectureCode, props.prefectures]);

  return (
    <div>
      <div className="flex items-center cursor-pointer" onClick={onChange}>
        {opened && <AiOutlineDown />}
        {!opened && <AiOutlineRight />}
        <div className="ml-2">{props.label}</div>
      </div>
      {opened && (
        <div className="m-4 flex flex-col gap-4">
          {props.prefectures.map((item, index) => {
            const label = getPrefectureName(item);
            return (
              <label className="cursor-pointer" key={index}>
                <input
                  type="radio"
                  name="prefectureCode"
                  checked={item === props.selectedPrefectureCode}
                  onChange={() => {
                    props.onChangePrefectureCode(item);
                  }}
                />
                <span className="ml-2">{label}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CorpListSideMenuTreeNode;
